import { useState } from "react";

import { Grid, Typography, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import constants from "../../../../utils/constants";
import LitcoInfoDialog from "../../../UI/LitcoInfoDialog";

export default function TooltipQuestion(props) {
  let dialogText = props.dialogText.split("#");
  dialogText.splice(
    1,
    0,
    <strong key={props.index}>
      <a href={"tel:+" + constants.LITCO_NUMBER}>{constants.LITCO_NUMBER}</a>
    </strong>
  );

  const [dialogOpen, setDialogOpen] = useState(false);

  const dialogOpenHandler = () => {
    setDialogOpen(true);
  };

  const dialogCloseHandler = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={10}>
          <Typography variant="body1" maxWidth={290}>
            {props.questionText}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Tooltip title="Have you answered NO to this question? Click here to know more." placement="right">
            <IconButton onClick={dialogOpenHandler}>
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      <LitcoInfoDialog type="info" title="Have You Answered No?" open={dialogOpen} onClose={dialogCloseHandler}>
        {dialogText}
      </LitcoInfoDialog>
    </>
  );
}
